import { render, staticRenderFns } from "./DashboardTvAtendimentos.vue?vue&type=template&id=461db0b7"
import script from "./DashboardTvAtendimentos.vue?vue&type=script&lang=ts"
export * from "./DashboardTvAtendimentos.vue?vue&type=script&lang=ts"
import style0 from "./DashboardTvAtendimentos.vue?vue&type=style&index=0&id=461db0b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports